export default "__VITE_ASSET__D163hoA___"